export default "__VITE_ASSET__DFmgLJzK__"